import React from 'react';
import { ReactComponent as SearchIcon } from "@/assets/svgs/DesignSystem/search-icon.svg";
import Input from '@/componentsDS/Input/index';
import PropTypes from 'prop-types';

const Search = ({ name, value, placeholder, variant = 'outlined', disabled = false, onCancel = () => {}, onChange, id }) => {
    return <Input placeholder={placeholder ?? 'Search'} name={name ?? 'search'} value={value} prefixIcon={<SearchIcon />} onCancel={onCancel} onChange={onChange} variant={variant} disabled={disabled} id={id} />;
};

Search.propTypes = {
    name: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    variant: PropTypes.string,
    disabled: PropTypes.bool,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    id: PropTypes.string
};


export default Search;
